var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "progress",
        {
          staticClass: "progress is-medium",
          class: _vm.getPorcentajeColor,
          attrs: { max: "100" },
          domProps: { value: _vm.getPorcentaje },
        },
        [_vm._v(_vm._s(_vm.getPorcentaje) + "%")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "has-text-centered" }, [
        _c("i", { staticClass: "fas fa-tachometer-alt fa-fw" }),
        _vm._v(
          " Progreso - " +
            _vm._s(_vm.getCantidad) +
            " de " +
            _vm._s(_vm.isDisponible ? "1 Firma" : "2 Firmas") +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.tableData,
            bordered: false,
            narrowed: true,
            hoverable: true,
            loading: false,
            "mobile-cards": true,
          },
        },
        [
          _c("b-table-column", {
            attrs: { field: "id", label: "Orden", width: "40", numeric: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v("\n        # " + _vm._s(props.row.id) + "\n    "),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { label: "Nombre y Apellido" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-user fa-fw" }),
                      _vm._v(" " + _vm._s(props.row.usuario) + " "),
                      props.row.pendiente
                        ? _c("i", { staticClass: "fas fa-arrow-left fa-fw" })
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { label: "Rol" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v("\n        " + _vm._s(props.row.rol) + "\n    "),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { label: "Firmado", centered: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("i", {
                      staticClass: "fas fa-fw is-size-5",
                      class: props.row.icon,
                      attrs: { alt: props.row.altIcon },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5" }, [
      _c("i", { staticClass: "fas fa-sitemap fa-fw" }),
      _vm._v(" Circuito de firmas"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }